'use client';
import { type ComponentType } from 'react';
import type { Props } from './storefinder.component';
import dynamic from 'next/dynamic';

const DynamicStorefinderComponent: ComponentType<Props> = dynamic(
  () => import('./storefinder.component')
);
export default DynamicStorefinderComponent;
